import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import User from '@shared/models/User';
import { UserService } from '@shared/requests/user.service';
import { TokenStorageService } from '@auth/services/token-storage.service';
import { LocalizationService } from './localization.service';

@Injectable({
  providedIn: 'root'
})
export class UserContextService {
  private currentUserData = new BehaviorSubject<User | null>(null);

  public currentUser = this.currentUserData.asObservable();

  constructor(private userService : UserService, private tokenService : TokenStorageService) {

  }

  public updateData(data : User) {
    this.currentUserData.next(data);
  }

  public async reloadCurrentUserIfNull() : Promise<User | null> {
    try {
      let user = await firstValueFrom(this.currentUser);

      if (user == null) {
        user = await this.reloadCurrentUser();

        return user;
      }

      return user;
    }
    catch (e) {
      return null;
    }
  }

  private checkLang(userTmp : any) : void {
    try {
      if (userTmp.lang !== LocalizationService.DEFAULT_LOCALE) {
        this.userService.updateLang({ lang: LocalizationService.DEFAULT_LOCALE } as User).finally(() => {});
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  public async reloadCurrentUser() : Promise<User> {
    try {
      if (await this.tokenService.getToken()) {
        const userTmp = await this.userService.me();

        this.checkLang(userTmp);
        this.updateData(userTmp);
        return userTmp;
      }
    }
    catch (e) {
      return Promise.reject(new Error('Not connected ?'));
    }

    return Promise.reject(new Error('Not connected ?'));
  }

  public clear() : void {
    this.currentUserData.next(null);
  }
}
